module.exports = __webpack_public_path__ + "static/media/menu-billing.a8a08c62.svg";